import { render } from "./TryOnModelManage.vue?vue&type=template&id=47352189&scoped=true"
import script from "./TryOnModelManage.vue?vue&type=script&lang=js"
export * from "./TryOnModelManage.vue?vue&type=script&lang=js"

import "./TryOnModelManage.vue?vue&type=style&index=0&id=47352189&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47352189"]])

export default __exports__